export const HOME_PATH = '/';

export const SETTINGS_PATH = 'settings';

export const DATA_CONTROLS_PATH = 'data-controls';

export const DEPENDENTS_PATH = 'dependents';

export const CONVERSATIONS_PATH = 'conversations';

export const CONVERSATION_PATH = `${CONVERSATIONS_PATH}/:conversationId`;

export const getConversationPath = (conversationId: string): string =>
  `/${CONVERSATIONS_PATH}/${conversationId}`;

export const EXPERIENCES_PATH = 'experiences';

export const EXPERIENCE_PATH = `${EXPERIENCES_PATH}/:experienceId`;

export const EXPERIENCE_SUMMARY_PATH = 'summary';

export const EXPERIENCE_LINK_PATH = 'experience/:experienceId/*';

export const getExperiencePath = (experienceId: string): string =>
  `/${EXPERIENCES_PATH}/${experienceId}`;

export const getExperienceSummaryPath = (experienceId: string): string => {
  const experiencePath = getExperiencePath(experienceId);

  return `${experiencePath}/${EXPERIENCE_SUMMARY_PATH}`;
};

export const TICKETS_PATH = 'tickets';

export const TICKET_PATH = `${TICKETS_PATH}/:displayId`;

export const TICKET_LINK_PATH = 'ticket/:displayId';

export const getTicketPath = (displayId: string): string =>
  `/${TICKETS_PATH}/${displayId}`;
